function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading } from '../../atoms';
import { ProfileImage } from '../ProfileImage';
import ReactConfig from '../../ReactConfig';
export default function SimpleProfileCard(param) {
    var image = param.image, title = param.title, subtitle = param.subtitle, accentColor = param.accentColor, action = param.action, className = param.className;
    var LinkComponent = ReactConfig.LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        draggable: false,
        className: "block"
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('p-6 bg-bg-subtle rounded-xl', image && 'md:py-7')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row items-center md:flex-col md:items-stretch"
    }, !!image && /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ React.createElement(ProfileImage, {
        color: accentColor,
        image: image,
        className: "w-[4.125rem] md:w-[6rem]"
    })), /*#__PURE__*/ React.createElement("div", {
        className: twMerge(!!image && 'ml-6 md:mt-7')
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!subtitle && /*#__PURE__*/ React.createElement(Body, {
        className: "mt-3"
    }, subtitle))))));
}

//# sourceMappingURL=SimpleProfileCard.js.map